import { Sparkles, Zap, Target } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";

const HeroSection = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const features = [
    {
      title: "No Sign-up",
      description: "Start instantly",
      icon: Sparkles,
    },
    {
      title: "AI Generated",
      description: "Smart questions",
      icon: Zap,
    },
    {
      title: "Instant Results",
      description: "Clear analytics",
      icon: Target,
    },
  ];

  const tags = ["Fast", "No sign-up", "Privacy-friendly", "Shareable results"];

  return (
    <div className="space-y-8">
      <div className="space-y-6">
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-primary leading-tight">
          Learn Smarter with AI
        </h1>
        <p className="text-lg sm:text-xl text-muted-foreground max-w-md">
          Generate personalized quizzes on any topic in seconds
        </p>
        <p className="text-base text-muted-foreground max-w-lg">
          Create a quiz, practice, and see results — clean and fast.
        </p>
      </div>


      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {features.map((feature, index) => {
          const Icon = feature.icon;
          return (
            <article
              key={index}
              className="bg-card rounded-2xl p-6 border border-border hover:shadow-card transition-smooth"
            >
              <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center mb-4">
                <Icon className="w-6 h-6 text-primary" aria-hidden="true" />
              </div>
              <h2 className="font-bold text-lg mb-1">{feature.title}</h2>
              <p className="text-sm text-muted-foreground">
                {feature.description}
              </p>
            </article>
          );
        })}
      </div>

      <div className="flex flex-wrap gap-3" role="list" aria-label="Features">
        {tags.map((tag, index) => (
          <span
            key={index}
            className="text-sm text-muted-foreground px-0"
            role="listitem"
          >
            {tag}
            {index < tags.length - 1 && (
              <span className="mx-3 text-muted-foreground/40" aria-hidden="true">•</span>
            )}
          </span>
        ))}
      </div>
    </div>
  );
};

export default HeroSection;
